module.exports = __webpack_public_path__ + "img/powered-by.79901262.svg";